import '../styles/animation.css';
import React, { useState } from 'react';

const ShipSlider = ({ toggleShip, shipCost }) => {
    // Track the slider state
    const [isShip, setIsShip] = useState(false);

    const handleToggle = (event) => {
        // Update the state based on checkbox
        const shipSelected = event.target.checked;
        setIsShip(shipSelected);

        // Call the toggleShip function with true if "Ship it!" is selected, false otherwise
        toggleShip(shipSelected);
    };

    return (
        <div className="slider-container">
            <div className={`option ${!isShip ? 'active' : ''}`} id="option1">
                Hold
            </div>
            <label className="toggle">
                <input
                    type="checkbox"
                    id="slider"
                    checked={isShip}
                    onChange={handleToggle}
                />
                <span className="slider"></span>
            </label>
            <div className={`option ${isShip ? 'active' : ''}`} id="option2">
                Ship it! (+{shipCost})
            </div>
        </div>
    );
};

const BountySlider = ({ toggleShip }) => {
    // Track the slider state
    const [isShip, setIsShip] = useState(false);

    const handleToggle = (event) => {
        // Update the state based on checkbox
        const shipSelected = event.target.checked;
        setIsShip(shipSelected);

        // Call the toggleShip function with true if "Ship it!" is selected, false otherwise
        toggleShip(shipSelected);
    };

    return (
        <div className="slider-container">
            <div className={`option ${!isShip ? 'active' : ''}`} id="option1">
                Hold
            </div>
            <label className="toggle">
                <input
                    type="checkbox"
                    id="slider"
                    checked={isShip}
                    onChange={handleToggle}
                />
                <span className="slider"></span>
            </label>
            <div className={`option ${isShip ? 'active' : ''}`} id="option2">
                Ship it! (+10.00)
            </div>
        </div>
    );
};

export {ShipSlider, BountySlider}
